import React, { Suspense } from "react";
import Context from "./Context";
import { Outlet } from "react-router-dom";
import Loader from "./components/shared/Loader";
import { CheckoutContextProvider } from "./CheckoutContext";
import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

function App() {
  const cioanalytics = AnalyticsBrowser.load({
    writeKey: "db6c1673b980531a8a0f",
    cdnURL: "https://cdp-eu.customer.io",
  });
  return (
    <Suspense fallback={<Loader />}>
      <Context cioanalytics={cioanalytics}>
        <CheckoutContextProvider>
          <Outlet />
        </CheckoutContextProvider>
      </Context>
    </Suspense>
  );
}

export default App;
